import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { ServiceModule } from '../providers/service.module';
import { MyApp } from './app.component';
import { ComponentsModule } from '../components/components.module';
import { CalendarModule } from 'angular-calendar';
import { DatetimePickerModule } from 'ion-datetime-picker-sn';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from '../Utils/TranslateUtils'
import { HttpClient } from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeNl from '@angular/common/locales/nl';

registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeNl);

@NgModule({
	declarations: [
		MyApp
	],
	imports: [
		BrowserModule,
		IonicModule.forRoot(MyApp, {
			tabsPlacement: 'top',
			mode: "ios",
		}),
		ServiceModule.forRoot(),
		CalendarModule.forRoot({}),
		ComponentsModule,
		DatetimePickerModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [HttpClient]
			}
		}),
	],
	bootstrap: [IonicApp],
	entryComponents: [
		MyApp
	],
	providers: [
		StatusBar,
		SplashScreen,
		{ provide: ErrorHandler, useClass: IonicErrorHandler }
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts